function idOf(ref) {
  if (!ref) return null;
  if (typeof ref === "string") return ref;
  if (ref._id) return String(ref._id);
  return String(ref);
}

export function computeLevel({ amount, pointsPerLevel } = {}) {
  const rawAmount = Number(amount);
  const pts = Number.isFinite(rawAmount) ? rawAmount : 0;
  const safeAmount = Math.max(0, pts);
  const step = Number(pointsPerLevel);

  if (!Number.isFinite(step) || step <= 0) {
    return {
      level: 0,
      remainder: safeAmount,
      pointsPerLevel: null,
      nextLevelAt: null,
    };
  }

  const level = Math.floor(safeAmount / step);
  const remainder = safeAmount - level * step;
  return {
    level,
    remainder,
    pointsPerLevel: step,
    nextLevelAt: (level + 1) * step,
  };
}

function findBalanceRow(pointBalances = [], pointTypeId) {
  const id = idOf(pointTypeId);
  if (!id) return null;
  return (
    (pointBalances || []).find((entry) => idOf(entry?.pointType) === id) || null
  );
}

function formatUsd(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "-";
  return n.toLocaleString("zh-HK", {
    style: "currency",
    currency: "USD",
    currencyDisplay: "code",
  });
}

export function formatLevelProgress({ remainder, pointsPerLevel, nextLevelAt } = {}) {
  if (nextLevelAt == null) return "-";
  return `${formatUsd(remainder || 0)} / ${formatUsd(pointsPerLevel)}`;
}

export function resolveUserLevels({ pointBalances = [], levelTypes = [] } = {}) {
  return (levelTypes || [])
    .filter((levelType) => (levelType?.status || "ACTIVE") === "ACTIVE")
    .map((levelType) => {
      const row = findBalanceRow(pointBalances, levelType.pointType);
      const amount = Number(row?.amount);
      const progress = computeLevel({
        amount: Number.isFinite(amount) ? amount : 0,
        pointsPerLevel: levelType.pointsPerLevel,
      });
      return {
        levelType,
        pointType: row?.pointType || levelType.pointType,
        amount: Number.isFinite(amount) ? amount : 0,
        ...progress,
      };
    });
}
